import { toast } from "@/components/ui";
import { usePatientAllergies } from "@/features/Patient/MedicalRecords/MedicationsAllergies/network/useAllergies";
import { useCoreVitals } from "@/features/Patient/PatientBar/network/useCoreVitals";
import { useEffect } from "react";
import { useLimitedAccess } from "../network/useLimitedAccess";
import { usePatientDemographics } from "../network/usePatientDemographics";

export const usePatientBarData = (patientId: string) => {
  const demographics = usePatientDemographics(patientId);
  const allergies = usePatientAllergies({ patientId });
  const limitedAccess = useLimitedAccess(patientId);
  const coreVitals = useCoreVitals(patientId);

  useEffect(() => {
    if (allergies.isError) {
      toast.error("Failed to fetch patient allergies", {
        id: "patient-allergies-error",
      });
    }
  }, [allergies.isError]);

  useEffect(() => {
    if (demographics.isError) {
      toast.error("Failed to fetch patient demographics", {
        id: "patient-demographics-error",
      });
    }
  }, [demographics.isError]);

  useEffect(() => {
    if (limitedAccess.isError) {
      toast.error("Failed to fetch patient status", {
        id: "patient-limited-access-error",
      });
    }
  }, [limitedAccess.isError]);

  useEffect(() => {
    if (coreVitals.isError) {
      toast.error("Failed to fetch patient core vitals", {
        id: "patient-core-vitals-error",
      });
    }
  }, [coreVitals.isError]);

  return {
    demographics,
    allergies,
    limitedAccess,
    coreVitals,
    isLoading: demographics.isLoading || allergies.isLoading,
    hasDemographicsError: demographics.isError,
    hasAllergiesError: allergies.isError,
    refetchDemographics: demographics.refetch,
  };
};
